const cn = {
    "Hi":"你好",
    "Home":"首页",
    "My_Credit":"财富中心",
    "Transaction_Records2":"交易记录",
    "Merchant_Center":"商户中心",
    "Opened_platform":"开放平台",
    "Help_center":"帮助中心",
    "Collaboration_Platform":"合作平台",
    "Live_CS_":"在线客服 ",
    "Customer_Hotline":"客服热线",
    "Monday_to_Friday":"周一到周五",
    "Login_to_Security_Center":"登录安全中心",
    "Logout":"退出",
    "Security_center":"安全中心",
    "Customer_Service":"客服中心",
    "Login_by_QR_code":"扫码登录",
    "login_through_Account_information":"账号登录",
    "Enter_your_Hp_No_or_email":"请输入手机号或邮箱",
    "Enter_the_password":"请输入密码",
    "Enter_verification_code":"请输入验证码",
    "forget_password":"忘记密码",
    "Login":"登 录 ",
    "Register_an_account":"注册账号",
    "Become_a_Merchant":"成为商家",
    "Other_login_methods":"其他登录方式",
    "Platform_opened_function":"平台开放功能 ",
    "Payment_function":"支付功能",
    "Meet_the_payment_requirements":"满足用户在各种支付环境中快速收付款",
    "Multicurrency_payment_selection":"多币种支付",
    "Supports_currency_transactions_in_China_Malaysia_Thailand_and_others":"支技中国、马来西亚、泰国等多个国家币种交易",
    "MultiCountry_Services":"多国家服务",
    "Set_up_branches_in_multiple_countries_in_order_to_provide_a_good_quality_services_to_users":"在多个国家设置分公司，为用户提供优质服务",
    "Security_protected":"安全保障",
    "Continuously_enhance_user_protection":"不断开发技术能力，为用户提供全方位保障",
    "APP_download":"APP下载 ",
    "Payments_transfers_etc":"付款、转账等",
    "Effortless_APP":"生活问题由EGC56支付APP",
    "Serving_you":"为您服务！",
    "Download_A5B_Pay_APP_get_more_surprises":"下载EGC56支付APP，更多惊喜等着您！",
    "Download_from_the_app_store":"App Store 下载 ",
    "download_at_Google_play":"应用商店下载 ",
    "Morning":"上午好",
    "Afternoon":"中午好",
    "Evening":"下午好",
    "Last_login":"上次登录",
    "Credit_balance2":"账户余额充值 ",
    "Asia5b_pays_support_with_QR_code_scan_more_convenient_Support_RMB_Malaysian_Ringgit_and_other_currencies":"EGC56支付APP扫扫，充值更方便。支持人民币、马币等多个币种充值交易。 ",
    "Bind_payment_method":"绑定支付 ",
    "Add_method":"添加平台",
    "Bind_payment_method2":"可绑平台",
    "Account_navigation":"账户导航 ",
    "Balance":"余额",
    "Top_up":"充值",
    "Withdraw":"提现",
    "Minimum_withdrawal_amount":"最低提现金额",
    "Fund_Transfer":"转账",
    "Inquiry":"查询",
    "More_currencies_selection":"更多币种",
    "Recent_transaction_records":"最近消费记录",
    "Transaction_records":"消费记录",
    "Balance_record":"余额记录",
    "Classification":"分类",
    "Date":"日期",
    "Remark":"备注 ",
    "Transaction_number":"交易号",
    "Amount":"金额",
    "Currency":"币种",
    "Payment_method":"支付方式",
    "Transaction_Type":"交易类型",
    "Status":"交易状态",
    "Operate":"操作",
    "View":"查看",
    "Pay":"支付",
    "Alipay":"支付宝",
    "WeChat":"微信",
    "Credit_card":"信用卡",
    "Billplz":"Billplz",
    "FPX":"FPX",
    "Processing":"进行中",
    "Pending_payment":"待付款",
    "Successful_transaction":"交易成功",
    "Refunding":"退款中",
    "refunded":"已退款",
    "Shipped":"已发货",
    "Transaction_failed":"交易失败",
    "Refund":"退款",
    "Collect_Fund":"收款",
    "Commission_Withdraw":"提佣",
    "Credited_Amount":"增加余额",
    "Auto_Debit":"自动扣款",
    "Spend":"消费",
    "Amount_to_be_paid":"待支付金额",
    "Order_payment":"下单支付",
    "Select_the_top_up_amount":"请选择充值金额",
    "Or_enter_the_amount_manually":"或者手动输入金额",
    "Please_enter_the_amount":"请输入金额",
    "Alipay_processing_fee":"支付宝支付手续费",
    "Please_scan_with_Alipay":"请使用支付宝扫一扫",
    "Scan_QR_code_to_pay":"扫描二维码支付",
    "Please_enter_the_correct_amount":"请输入正确的金额",
    "Payment_steps":"支付的步骤",
    "Complete_the_transfer":"完成转账",
    "submit_application":"提交申请",
    "Waiting_for_confirmation":"等待确认",
    "Perform_mutitop_up_at_one_time_avoid_transferring_integer_amounts_such_as_RM100_RM50_etc_Adding_a_decimal_point_such_as_RM10003_or_RM49_for_easy_verification":"为了付款方便，您可以一次性多充值，尽量避免转整数金额如 RM100，RM50等， 在整数金额后面加个零头如RM100.03，或者RM49.99会减少确认到账的等待时间。",
    "Account_holder":"账号持有者",
    "Please_select_the_transfer_bank":"请选择转账银行",
    "Main_site":"网站入口",
    "Transaction_notice":"为了更快的确认到帐，我们建议您在做网上转账的时候把 My Intial 设置设成为您 EGC56 的用户名。",
    "Transfer_completed":"已完成转账",
    "Please_fill_in_the_transfer_information_for_the_financial_department_to_confirm_the_payment":"请填写转账信息以便财务部门确认款项",
    "Ho_No":"手机号码",
    "Please_enter_the_Hp_No":"请输入手机号码",
    "Transfer_to_bank":"转入银行",
    "Transfer_to_bank_account":"转入银行帐号",
    "Please_choose_to_transfer_to_bank":"请选择转入银行",
    "Please_choose_to_transfer_to_bank_account":"请选择转入银行帐号",
    "Transfer_from_bank":"转出银行",
    "Please_select_a_transfer_from_bank":"请选择转出银行",
    "reference_number":"流水号 (Reference Number)",
    "Please_enter_the_reference_number":"请输入流水号",
    "Transfer_time":"转账时间",
    "Please_select_a_transfer_time":"请选择转账时间",
    "Upload_receipt2":"上传凭证",
    "Submit_top_up":"提交充值",
    "top_up_successful":"充值成功",
    "Please_wait_patiently_for_the_verification_revert_back_a_message_once_completed_Refer_top_up_status_for_transaction_history":"请您耐心等候审核，审核通过后我们会将信息发送至您 的手机上。您可以在交易记录中查看充值状态。",
    "Next_top_up":"继续充值",
    "Enter_CVV2":"请输入CVV2",
    "Enter_the_correct_CVV2":"请输入正确的CVV2",
    "Enter_the_correct_transfer_time":"请输入正确的转账时间",
    "Select_the_transfer_time":"请选转账时间",
    "Upload_receipt":"请上传凭证",
    "Submission_Failed":"提交失败",
    "Confirm2":"确定",
    "Fail_to_upload":"上传失败",
    "Selected_Bank":"所属银行",
    "Select_your_bank":"请选择所属银行",
    "CreditNeedAddress": "使用信用卡需要完善您的地址信息，点击确定完善资料.",
    "Credit_Card_No":"信用卡卡号",
    "Enter_Credit_Card_No":"请输入信用卡卡号",
    "YourIdType": "你的证件类型",
    "Cardholders_Name":"持卡人姓名",
    "Fill_in_cardholder_name":"请输入持卡人姓名",
    "Expire_date":"到期时间",
    "Select_credit_card_expiration_time":"请选择信用卡到期时间",
    "I_have_read_and_agree_to_the_Credit_Card__Debit_Card_Terms_and_Conditions":"我已阅读并同意《信用卡/借记卡条款和条件》",
    "Next_step":"下一步",
    "Top_up_successful_access_My_Credit_to_check_the_your_balance":"充值成功，请进“财富中心”查看余额",
    "Select_bank_for_transfer":"选择转账银行",
    "Email_address":"电子邮箱",
    "Enter_your_email_address":"请输入邮箱",
    "I_have_read_and_agree_to_the_FPX_Terms_and_Conditions":"我已阅读并同意《FPX条款》",
    "Enter_your_correct_email_address":"请输入正确的邮箱",
    "WeChat_processing_fee":"微信支付手续费",
    "Please_scan_using_WeChat":"请使用微信扫一扫",
    "Check_the_top_up_status_in_the_transaction_history":"您可以在交易记录中查看充值状态。",
    "Changable_amount":"变动金额",
    "Credit_Balance":"账户余额",
    "transaction_currency":"交易币种",
    "Congratulations":"恭喜您！",
    "The_system_is_processing":"系统正在为您跳转",
    "Bind_account":"绑定账号",
    "Unbind_it":"解除绑定",
    "Bind_now":"立即绑定",
    "Username2":"用户名",
    "Password":"密码",
    "Cancel":"取 消",
    "Confirm":"确 定",
    "Amall_Marketplace":"Amall商城",
    "Shipforme":"集运网",
    "Buyforme":"代购网",
    "Live_Video":"直播网",
    "Please_enter_username":"请输入用户名",
    "Unbind_account":"解除账号绑定",
    "Account_binding":"账号绑定",
    "Successful_operate":"操作成功！",
    "Upload_image":"上传头像",
    "Phone_number":"手机",
    "Modify":"修改",
    "Email":"邮箱",
    "image_supported_with_JPG_PNG_format":"图片只能是 JPG , PNG 格式!",
    "Login_password2":"登录密码",
    "A5bpay_Password_to_login":"登录EGC56支付账户时需要输入的密码",
    "Reset":"重置",
    "Payment_password":"支付密码",
    "Password_needed_when_editing_info":"在账户资金变动，修改账户信息时需要输入的密码",
    "Download_APP":"APP下载",
    "4_to_20_characters_in_length":"长度在 6 到 20 个字符",
    "4_characters_in_length":"长度为4个字符",
    "Hotline":"唯一热线",
    "All":"全部",
    "Time_period":"时间范围",
    "Start_date":"开始日期",
    "End_date":"结束日期",
    "to":"至",
    "More_filters":"更多筛选条件",
    "Amount_range":"金额范围",
    "Enter_starting_amount":"输入起始金额",
    "Enter_end_amount":"输入结束金额",
    "Keywords":"关键字",
    "Enter_keywords":"输入关键字",
    "IN":"收入",
    "OUT":"支出",
    "last_week":"最近一周",
    "last_month":"最近一个月",
    "last_three_months":"最近三个月",
    "Initialize_payment_password":"初始化支付密码",
    "Set_up_payment_password":"设置支付密码",
    "Confirm_payment_password":"确认支付密码",
    "Password_consists_of_6_digits":"密码为 6 个数字组成",
    "Please_enter_the_password_again":"请再次输入密码",
    "The_passwords_entered_twice_are_inconsistent":"两次输入密码不一致!",
    "Set_up_successfully":"设置成功",
    "Login_failed":"登录失败",
    "checkout_counter":"收银台",
    "order_number":"订单号",
    "yuan":"元",
    "Order_time":"购买时间",
    "Order_details":"订单详情",
    "Back_to_pay_with_balance":"返回使用余额支付",
    "Your_account_has_no_balance_please_top_up_":"您的账户还没有余额，请先充值",
    "Or_click_other_payment_methods_choose_Alipay_or_WeChat_pay":"或点击其他付款方式，选择支付宝或者微信进行支付",
    "pending_to_be_pay":"待支付",
    "Your_xx_account_balance_is_insufficient_please_top_up":"您的xx账户余额不足，请充值！",
    "Topup_balance_select_new_currency":"充值余额/开通新币种",
    "Other_payment_methods":"其他付款方式",
    "Please_enter_the_payment_password":"请输入支付密码",
    "Forget_password":"忘记密码?",
    "Confirm_payment":"确认付款",
    "Payment_failed":"支付失败",
    "Please_select_a_payment_currency":"请选择支付币种",
    "Account_balance_is_insufficient_please_top_up":"账户余额不足请先充值",
    "Payment_successful":"支付成功",
    "Confirmation_message":"确认信息",
    "Select_Payment_Method":"选择支付方式",
    "A5bpay":"EGC56支付",
    "Provide_best_quality_security_":"为您提供最优质的安全保障",
    "Sign_Up":"会员注册",
    "Create_Account":"创建账户",
    "Set_login_password":"设置登录密码",
    "Payment_settings":"支付设置",
    "Complete":"完成",
    "Nationality__Region":"所在国籍/地区",
    "Please_select_your_nationality__region":"请选择所在国籍/地区",
    "SMS_verification_code":"短信校验码",
    "In_order_to_provide_you_with_better_financial_services_identity_information_cannot_be_changed_once_it_is_entered_and_private_information_is_strictly_confidential_without_my_permission":"为了给您提供更好的金融服务，身份信息一经录入不得更改，隐私信息未经本人许可严格保密。",
    "Username":"账户名",
    "Login_password":"登陆密码",
    "Please_enter_your_login_password":"请输入登陆密码",
    "Reenter":"再次输入",
    "Confirm_submission":"确认提交",
    "Registration_success":"注册成功",
    "You_have_successfully_log_in_to_Wu_Shiyi_payment_account":"您已成功注EGC56支付账号！",
    "The_email_has_been_registered":"该邮箱已注册!",
    "please_enter_a_valid_phone_number":"请输入正确的手机号!",
    "The_phone_number_has_been_registered":"该手机号已注册!",
    "Get_verification_code":"获取验证码",
    "Get_the_code_after_3s":"3s后重新获取",
    "Verification_code_verified_failed":"验证码验证失败",
    "Top_up_your_account_balance":"账户余额充值",
    "A5b_pays_support_scan_QR_code_making_top_up_more_convenient_Support_RMB_Malaysian_Ringgit_and_other_currencies_for_topup_transactions":"EGC56支付APP扫扫，充值更方便。支持人民币、马币等多个币种充值交易。",
    "Top_up_now":"立即充值",
    "Processing_fee":"服务费",
    "Balance_withdrawal": "提现到账金额",
    "Service_Fee":"服务费",
    "Rate":"费率",
    "A_single_service_charge_is_a_minimum_of_0_1_yuan":"单笔服务费最低0.1元！",
    "Total_paid":"实付总额",
    "Merchant_order_number":"商户订单号",
    "Counterparty_information":"对方信息",
    "Creation_time":"创建时间",
    "Payment_time":"付款时间",
    "End_Time":"结束时间",
    "Merchant_description":"商家描述",
    "Merchant_name":"商家名称",
    "Tips_System_automatically_notify_the_payee_of_the_transfer_result":"温馨提示：系统会自动将转账结果通知收款人。",
    "Payee_phone_Number__Email_Address":"收款人手机号码 / 邮箱",
    "Please_enter_your_mobile_number__email_address":"请输入手机号码 / 邮箱",
    "Transfer_amount":"转账金额",
    "Please_enter_the_transfer_amount":"请输入转账金额",
    "Transfer_remark":"转账备注",
    "Please_enter_a_transfer_remark":"请输入转账备注",
    "I_have_read_and_agree_to_the_Transfer_Terms_and_Conditions":"我已阅读并同意《转账条款》",
    "Confirm_transferred":"确认转账",
    "Successful_transfered_about_to_enter_the_Fortune_Center_page":"转账成功，即将进入“财富中心”页面",
    "Submitted_successfully":"提交成功",
    "Continue_to_transfer":"继续转账",
    "Please_enter_the_correct_transfer_amount":"请输入正确的转账金额",
    "Your_account_does_not_have_sufficient_balance":"您的账户没有足够的余额",
    "Please_enter_the_payee_phone_number__email_addres":"请输入收款人手机号码 / 邮箱",
    "Please_enter_the_correct_payee_mobile_number__email_address":"请输入正确的收款人手机号码 / 邮箱",
    "This_account_has_insufficient_balance_to_transfer_please_choose_an_account_with_a_balance_thank_you":"该账户没有余额可以转账，请选择有余额的账户，谢谢！",
    "Basic_Information":"基本信息",
    "Security_Settings":"安全设置",
    "message_notification":"消息提醒",
    "Withdrawal_of_balance":"余额提现",
    "Cash_withdrawal":"取现金额",
    "Please_enter_the_amount_of_cash_withdrawal":"请输入取现金额",
    "account_type":"账户类型",
    "Please_select_an_account_type":"请选择账户类型",
    "debit_card":"借记卡",
    "cardholders_ID_number":"证件号码",
    "Please_enter_cardholders_ID_number":"请输入证件号码",
    "Bank_Account":"银行账号",
    "Please_enter_your_bank_account_number":"请输入银行账号",
    "I_have_read_and_agree_to_the_Withdrawal_Terms_and_Conditions":"我已阅读并同意《提现条款》",
    "The_amount_of_cash_withdrawal_cannot_be_greater_than_the_balance":"取现金额不能大于余额",
    "This_account_has_no_balance_to_withdraw_please_choose_an_account_with_a_balance_thank_you":"该账户没有余额可以提现，请选择有余额的账户，谢谢！",
    "Withdrawal_failed":"提现失败",
    "Your_login_status_has_expired_please_log_in_again":"您的登录状态已失效，请重新登录！",
    "Permission_error":"权限错误",
    "Data_acquisition_failed":"数据获取失败！",
    "Request_timed_out":"请求超时！",
    "Incorrect_file_parameters_please_confirm_if_a_file_is_passed_in":"文件参数错误，请确认是否传入了文件",
    "The_file_format_is_not_jpg_or_png_please_confirm_the_file_format":"文件格式不是jpg或者png，请确认文件格式",
    "Unsupported_file_format":"不支持的文件格式",
    "Browser_does_not_support_canvas":"浏览器不支持canvas",
    "Browser_does_not_support_FileReader":"浏览器不支持FileReader",
    "Image_load_failed":"图片获取失败",
    "AddAddress": "添加地址",
    "EditAddress": "修改地址",
    "Address_management": "地址管理",
    "Name": "姓名",
    "Address": "地址",
    "Tel": "联系电话",
    "Operation": "操作",
    "No_more_data": "暂无数据",
    "First_name": "姓",
    "Last_name": "名",
    "Country_code": "国家区号",
    "Country": "国家",
    "Province": "省",
    "City": "城市",
    "Detailed_address": "详细地址",
    "Zip": "邮编",
    "Set_default": "设置为默认",
    "After_successful_payment": "支付成功后，自动支付所选择的待付款订单（可选）",
	"BillplzTips": "billplz：即时到账，单笔手续费1.5马币; ",
    "EATMTips": "ebanking和ATM：24小时内到账，不收手续费。",
	"Bill": '票据',
    "View_the_bill": '查看票据',
    "Payment_Notes": '支付备注',
    "Payment_times": '支付时间',
    "Please_enter": '请输入',
    "Please_select": '请选择',
    "remark": '备注',
    "Please_enter_remark": '请输入备注',
}

export default cn

